<!-- eslint-disable -->
<template>
  <CommonPages id="category-list"
    :class="['category-list',deviceType === 'mobile' ? 'detect_deviece_mobile' : 'detect_deviece_pc']"
    :title="pageTitle" :metaDescription="pageDescription">
    <!-- 顶部标题区域 -->
    <div class="categories-container">
      <div class="categories-header" :class="[deviceType]">
        <div class="categories-title">{{ categoryTitle }}</div>
        <div class="categories-subtitle">{{ categoryDescription }}</div>
      </div>

      <AdComponent :key="'ads-category-list-1'"
        v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.categories_list_1"
        ref="ads-category-list-1" class="ad-width-100 pc_padding m_padding"
        :ads="adsensConfig?.categories_list_1" :showDebug="showDebug" />
    </div>

    <div class="similar-name-section" :class="[deviceType]">
      <!-- 结果标题区域 -->
      <div class="results-header" :class="[deviceType]">
        <!-- PC版布局 -->
        <template v-if="deviceType !== 'mobile'">
          <div class="results-dot"></div>
          <div class="results-title">Your Results</div>
          <div class="sort-container">
            <span class="sort-label">Sort By:</span>
            <el-select v-model="sortBy" class="sort-select" popper-class="sort-dropdown">
              <el-option v-for="item in sortOptions" :key="item.value" :label="item.label"
                :value="item.value" />
            </el-select>
          </div>
        </template>
        <!-- 移动端布局 -->
        <template v-else>
          <div class="results-header-top">
            <div class="results-dot"></div>
            <div class="results-title">Your Results</div>
          </div>
          <div class="sort-container">
            <span class="sort-label">Sort By:</span>
            <el-select v-model="sortBy" class="sort-select" popper-class="sort-dropdown">
              <el-option v-for="item in sortOptions" :key="item.value" :label="item.label"
                :value="item.value" />
            </el-select>
          </div>
        </template>
      </div>

      <!-- 名字列表区域 -->
      <div class="similar-names-list" :class="[deviceType]">
        <template v-for="(card, index) in nameCards">
          <router-link :key="index" :to="`/names/${card.name.toLowerCase()}/${card.id}`" tag="div"
            class="name-card-link">
            <div class="name-card" :class="[deviceType]" @mouseenter="hoveredCard = index"
              @mouseleave="hoveredCard = null">
              <div class="card-header">
                <div class="card-name">{{ card.name }}</div>
                <div class="card-gender-icon">
                  <img :src="card.genderIcon" alt="gender icon" />
                </div>
              </div>
              <div class="card-pronunciation">{{ card.pronunciation }}</div>
              <div class="card-divider"></div>
              <div class="card-details" :class="[deviceType]">
                <div class="card-detail">
                  <div class="detail-label">Style</div>
                  <div class="detail-value">{{ card.style }}</div>
                </div>
                <div class="card-detail">
                  <div class="detail-label">Meaning</div>
                  <div class="detail-value" :class="[deviceType]" v-if="deviceType == 'mobile'">
                    <span v-for="item in card.meaningList" :key="item">{{ item }}/</span>
                  </div>
                  <div class="detail-value" v-else>
                    <span v-for="item in card.meaningList" :key="item">{{ item }}</span>
                  </div>
                </div>
              </div>
              <div class="card-divider"></div>
              <div class="card-popularity">
                <div class="popularity-label">US Popularity</div>
                <div class="popularity-value">{{ card.popularity }}</div>
              </div>
            </div>
          </router-link>
          <!-- Mobile ad after 2nd card -->
          <AdComponent v-if="deviceType === 'mobile' && index === 1" :key="'ads-category-list-2'"
            v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.categories_list_2"
            ref="ads-category-list-2" class="ad-width-100 " :ads="adsensConfig?.categories_list_2"
            :showDebug="showDebug" />

          <!-- Mobile ad after 5th card -->
          <AdComponent v-if="deviceType === 'mobile' && index === 4" :key="'ads-category-list-3'"
            v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.categories_list_3"
            ref="ads-category-list-3" class="ad-width-100 " :ads="adsensConfig?.categories_list_3"
            :showDebug="showDebug" />

          <!-- PC ad after 8th card -->
          <AdComponent v-if="deviceType !== 'mobile' && index === 7" :key="'ads-category-list-2'"
            v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.categories_list_2"
            ref="ads-category-list-2" class="ad-width-100  ad-grid-full-width"
            :ads="adsensConfig?.categories_list_2" :showDebug="showDebug" />
        </template>
      </div>
    </div>

    <AdComponent v-if="deviceType != 'mobile' " :key="'ads-category-list-3'"
      v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.categories_list_3"
      ref="ads-category-list-3" class="ad-width-100 pc_padding"
      :ads="adsensConfig?.categories_list_3" :showDebug="showDebug" />

    <!-- 组合模块 -->
    <div class="combinations-section" :class="[deviceType]" v-if="combinations.length > 0">
      <div class="section-header">
        <div class="section-dot"></div>
        <div class="section-title">Combinations</div>
      </div>
      <div class="combinations-container">
        <div class="combination-row" :class="[deviceType]">
          <div class="combination-card" v-for="(combo, index) in combinations" :key="index"
            @click="navigateTo(combo.url)" @mouseenter="hoveredCombination = index"
            @mouseleave="hoveredCombination = null"
            :class="{'hovered': hoveredCombination === index}">
            <div class="combination-text">
              {{ combo.title }}
            </div>
            <div class="see-more-button">
              <span>See More</span>
              <img src="@/assets/default/arrow-right-small.svg" alt="arrow" class="arrow-icon" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <AdComponent v-if="deviceType === 'mobile' && nameCards < 4" :key="'ads-category-list-3'"
      v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.categories_list_3"
      ref="ads-category-list-3" class="ad-width-100 m_padding"
      :ads="adsensConfig?.categories_list_3" :showDebug="showDebug" />

    <section class="search-sec-row" :class="[deviceType]">
      <!-- 搜索过滤区域 -->
      <div class="section-header" :class="[deviceType]">
        <div class="section-dot"></div>
        <div class="section-title">Search by Filter</div>
      </div>

      <div class="names-filter" :class="[deviceType]">
        <SearchFilter />
      </div>
    </section>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import SearchFilter from '@/components/SearchFilter.vue';
import AdComponent from '@/pages/components/AdComponent.vue'
import '@/css/common.scss';

export default {
  name: 'CategoryList',
  components: {
    CommonPages,
    SearchFilter,
    AdComponent,
  },
  mixins: [common, adMixin, adTrackingMixin],
  data () {
    return {
      hoveredCard: null,
      hoveredCombination: null,
      nameCards: [],
      combinations: [],
      sortBy: 'S_3',
      sortOptions: [
        { value: 'S_1', label: 'A-Z' },
        { value: 'S_2', label: 'Z-A' },
        { value: 'S_3', label: 'Most Popular' },
        { value: 'S_4', label: 'Most Unique' }
      ],
    };
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'domainConfig',
      "adsensConfig",
      'adPosConfig',
      'showDebug',
    ]),
    // 获取路由参数
    categoryParams () {
      return {
        cate: this.$route.params.cate || 'gender',
        value: this.$route.params.value || 'boy',
      };
    },
    categoryTitle () {
      const { value } = this.categoryParams;
      return `Browse ${this.capitalize(value)} Names`;
    },
    categoryDescription () {
      const { value } = this.categoryParams;
      return `From timeless classics to hidden gems, our ${this.capitalize(value)} name list brings together inspiration, meaning, and beauty for your naming journey.`;
    },
    pageTitle () {
      const { value } = this.categoryParams;
      return `Browse ${this.capitalize(value)} Names`;
    },
    pageDescription () {
      const { value } = this.categoryParams;
      return `From timeless classics to hidden gems, our ${this.capitalize(value)} name list brings together inspiration, meaning, and beauty for your naming journey.`;
    }
  },
  methods: {
    async fetchNames () {
      const { cate, value } = this.categoryParams;
      const params = {
        origin: this.domainConfig?.origin || '',
        pageSize: 20,
        pageNum: 1,
        sortType: this.sortBy,
      };

      if (cate === 'gender' || cate === 'meaning' || cate === 'letter') {
        params[cate] = [this.capitalize(value)];
      } else if (cate === 'style' || cate === 'syllables') {
        params[cate] = this.capitalize(value);
      }

      try {
        const response = await this.$global.server.postAPI({
          method: 'post',
          params,
          url: '/name/page',
        });
        if (response.data && response.data.list) {
          this.nameCards = response.data.list.map(item => ({
            id: item.id || '',
            name: item.name || '',
            genderIcon: item.gender === 'Boy'
              ? require('@/assets/icons/male.svg')
              : item.gender === 'Unisex'
                ? require('@/assets/icons/unsex.svg')
                : require('@/assets/icons/female.svg'),
            pronunciation: item.pronunciation || '',
            style: item.style || '',
            meaningList: item.meaningList || [],
            popularity: item.popularity || ''
          }));
        } else {
          this.nameCards = [];
        }
      } catch (error) {
        console.error('Error fetching names:', error);
        this.nameCards = [];
      }
    },
    async fetchCombinations () {
      const origin = this.domainConfig?.origin || '';
      try {
        const params = { origin };
        const response = await this.$global.server.postAPI({
          method: 'get',
          params,
          url: '/name/combinations',
        });
        if (response.data && response.data.combinations) {
          this.combinations = response.data.combinations.slice(0, 4);
        }
      } catch (error) {
        console.error('Error fetching combinations:', error);
        this.combinations = [];
      }
    },
    navigateTo (url) {
      if (url) {
        this.$router.push(url);
      }
    },
    // 首字母大写
    capitalize (str) {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
  },
  watch: {
    sortBy () {
      this.fetchNames();
    },
    '$route.params': {
      handler () {
        this.fetchNames();
      },
      deep: true,
    },
  },
  beforeMount () {
    this.fetchNames();
    this.fetchCombinations();
  },
  async mounted () {
    await this.initAdSystem();
    // 确保在广告系统初始化后再初始化跟踪
    this.$nextTick(() => {
      this.initAdTracking();
    });
  },
};
</script>

<style lang="scss" >
@import '~@/css/variables.scss';
.el-select-dropdown__list {
	padding: rem(3) 0;
}
.el-select-dropdown__item {
	padding: 0 rem(3) !important;
}
.el-select-dropdown__item.selected {
	color: #a31984;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
	background: rgba(163, 25, 132, 0.1);
}
.el-form {
	padding-bottom: 0;
}
.el-input__inner {
	border-radius: rem(20);
	border: rem(2) solid rgba(163, 25, 132, 0.1);
	background: #fff;
}
.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input.is-focus .el-input__inner {
	border-color: #a31984;
}
.el-input__inner:hover {
	border-color: rgba(163, 25, 132, 0.3);
}
.el-select:hover .el-input__inner {
	border-color: rgba(163, 25, 132, 0.3);
}
.el-select .el-input__inner:focus {
	border-color: #a31984;
}
.el-select__caret {
	color: #a31984 !important;
}
.sort-select {
	width: rem(140);
	.el-input__inner {
		border: none;
		color: #a31984;
		padding: 0 !important;
		font-size: rem(16);
		font-style: normal;
		font-weight: 700;
		line-height: rem(16); /* 100% */
		text-transform: capitalize;
	}
}
.el-select__tags {
	max-width: calc(100% - rem(30));
}
.el-tag {
	background-color: rgba(163, 25, 132, 0.1);
	border-color: rgba(163, 25, 132, 0.2);
	color: #a31984;
}
.el-tag .el-tag__close {
	color: #a31984;
}
.el-tag .el-tag__close:hover {
	background-color: #a31984;
	color: #fff;
}

.detect_deviece_mobile {
	.el-select-dropdown__item {
		font-size: rem(13);
		line-height: rem(34);
		height: rem(34);
	}
	.el-input__inner {
		height: rem(60);
		padding: rem(18) rem(44) rem(18) rem(24);
		border-radius: rem(20);
		border: rem(2) solid rgba(163, 25, 132, 0.1);
		background: #fff;
		color: #03133a;
		font-size: rem(18);
		font-style: normal;
		font-weight: 700;
		line-height: rem(20); /* 111.111% */
		text-transform: capitalize;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		display: inline-block;
	}
	.el-input__suffix {
		right: rem(24);
	}
	.el-select__caret {
		display: flex !important;
		align-items: center !important;
		justify-content: center !important;
	}
	.sort-select {
		.el-input__inner {
			border: none !important;
			border-radius: 0;
			color: #a31984;
			font-size: rem(16);
			font-style: normal;
			font-weight: 700;
			height: rem(16); /* 100% */
			line-height: rem(16); /* 100% */
			text-transform: capitalize;
		}
		.el-input__suffix {
			right: rem(8);
		}
		.el-select__caret {
			font-size: rem(16);
		}
	}
}
</style>

<style lang="scss" >
@import '~@/css/variables.scss';
.el-select-dropdown__list {
	padding: rem(3) 0;
}
.el-select-dropdown__item {
	padding: 0 rem(3) !important;
}
.el-select-dropdown__item.selected {
	color: #a31984;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
	background: rgba(163, 25, 132, 0.1);
}
.el-form {
	padding-bottom: 0;
}
.el-input__inner {
	border-radius: rem(20);
	border: rem(2) solid rgba(163, 25, 132, 0.1);
	background: #fff;
}
.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input.is-focus .el-input__inner {
	border-color: #a31984;
}
.el-input__inner:hover {
	border-color: rgba(163, 25, 132, 0.3);
}
.el-select:hover .el-input__inner {
	border-color: rgba(163, 25, 132, 0.3);
}
.el-select .el-input__inner:focus {
	border-color: #a31984;
}

.detect_deviece_mobile {
	.el-select-dropdown__item {
		font-size: rem(13);
		line-height: rem(34);
		height: rem(34);
	}
	.el-input__inner {
		height: rem(60);
		padding: rem(18) rem(44) rem(18) rem(24);
		border-radius: rem(20);
		border: rem(2) solid rgba(163, 25, 132, 0.1);
		background: #fff;
		color: #03133a;
		font-size: rem(18);
		font-style: normal;
		font-weight: 700;
		line-height: rem(20); /* 111.111% */
		text-transform: capitalize;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		display: inline-block;
	}
	.el-input__suffix {
		right: rem(24);
	}
	.el-select__caret {
		display: flex !important;
		align-items: center !important;
		justify-content: center !important;
	}
	.sort-select {
		.el-input__inner {
			border: none !important;
			border-radius: 0;
			color: #a31984;
			font-size: rem(16);
			font-style: normal;
			font-weight: 700;
			height: rem(16); /* 100% */
			line-height: rem(16); /* 100% */
			text-transform: capitalize;
		}
		.el-input__suffix {
			right: rem(8);
		}
		.el-select__caret {
			font-size: rem(16);
		}
	}
}
</style>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.category-list {
	.categories-container {
		background: linear-gradient(180deg, rgba(163, 25, 132, 1) 0%, rgba(163, 25, 132, 0.6) 69.65%, rgba(163, 25, 132, 0) 100%);
		width: 100%;
		padding-bottom: rem(52);
	}

	// 顶部标题区域样式
	.categories-header {
		padding: rem(52) 0;
		display: flex;
		flex-direction: column;
		gap: rem(24);
		align-items: center;
		justify-content: center;
		position: relative;

		.categories-title {
			color: transparent;
			text-align: center;
			font-size: rem(52);
			line-height: rem(68);
			font-weight: 900;
			position: relative;
			-webkit-text-stroke: rem(1) #ffffff;
			background: linear-gradient(108.74deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0.8) 30%, rgba(255, 255, 255, 1) 100%);
			-webkit-background-clip: text;
			background-clip: text;
			padding: 0 rem(180);
		}

		.categories-subtitle {
			color: #ffffff;
			text-align: center;
			font-size: rem(20);
			line-height: rem(28);
			font-weight: 400;
			position: relative;
			padding: 0 rem(180);
		}

		&.mobile {
			padding: rem(32) rem(16);

			.categories-title {
				font-size: rem(32);
				line-height: rem(40);
				padding: 0;
			}

			.categories-subtitle {
				font-size: rem(16);
				line-height: rem(24);
				padding: 0;
			}
		}
	}

	// 结果标题区域样式
	.results-header {
		padding: 0 rem(180) rem(24) rem(180);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		position: relative;

		.results-dot {
			background: #a31984;
			border-radius: rem(100);
			width: rem(8);
			height: rem(4);
			position: relative;
			margin-right: rem(16);
		}

		.results-title {
			color: #03133a;
			text-align: left;
			font-size: rem(28);
			line-height: rem(28);
			font-weight: 900;
			position: relative;
			margin-right: auto;
		}

		.sort-container {
			display: flex;
			flex-direction: row;
			gap: rem(8);
			align-items: center;
			justify-content: flex-end;
			position: relative;

			.sort-label {
				color: #374674;
				font-size: rem(14);
				line-height: rem(14);
				font-weight: 400;
			}

			:deep(.sort-dropdown) {
				.el-select-dropdown__item {
					color: #03133a;
					font-size: rem(14);
					line-height: rem(28);
					padding: rem(8) rem(16) !important;

					&.selected {
						color: #a31984;
						font-weight: 700;
					}

					&.hover,
					&:hover {
						background: rgba(163, 25, 132, 0.1);
					}
				}
			}
		}

		&.mobile {
			padding: rem(40) rem(16) rem(16) rem(16);
			flex-direction: column;
			align-items: flex-start;
			gap: rem(16);

			.results-header-top {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: flex-start;
				width: 100%;

				.results-dot {
					background: #a31984;
					border-radius: rem(100);
					width: rem(8);
					height: rem(4);
					position: relative;
					margin-right: rem(16);
				}

				.results-title {
					color: #03133a;
					text-align: left;
					font-size: rem(28);
					line-height: rem(28);
					font-weight: 900;
					position: relative;
					margin-right: 0;
				}
			}

			.sort-container {
				justify-content: flex-start;
			}
		}
	}

	// 搜索过滤区域样式
	.search-sec-row {
		gap: rem(24);
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
	}
	.names-filter {
		padding: 0 rem(180);
		display: flex;
		flex-direction: column;
		gap: rem(10);
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		position: relative;

		.filter-container {
			background: #f7f3f3;
			border-radius: rem(36);
			padding: rem(32);
			display: flex;
			flex-direction: column;
			gap: rem(48);
			align-items: flex-start;
			justify-content: flex-start;
			width: 100%;
			position: relative;

			.filter-rows {
				display: flex;
				flex-direction: column;
				gap: rem(24);
				align-items: flex-start;
				justify-content: flex-start;
				width: 100%;
				position: relative;

				.filter-row {
					display: flex;
					flex-direction: row;
					gap: rem(28);
					align-items: center;
					justify-content: flex-start;
					align-self: stretch;
					position: relative;

					.filter-item {
						display: flex;
						flex-direction: column;
						gap: rem(8);
						align-items: flex-start;
						justify-content: flex-start;
						flex: 1;
						position: relative;

						&.opacity-0 {
							opacity: 0;
						}

						.filter-label {
							padding: 0 rem(20);
							color: #03133a;
							text-align: left;
							font-size: rem(16);
							line-height: rem(16);
							font-weight: 400;
							position: relative;
						}

						:deep(.filter-select) {
							width: 100%;
							border-radius: rem(20);

							.el-input__wrapper {
								background: #ffffff;
								border-radius: rem(20);
								border: rem(2) solid rgba(163, 25, 132, 0.1);
								padding: rem(18) rem(24);
								box-shadow: none !important;
								height: rem(60);
								transition: all 0.3s ease;
								cursor: pointer;

								&:hover {
									border-color: rgba(163, 25, 132, 0.3);
								}

								&.is-focus {
									border-color: #a31984;
								}

								.el-input__inner {
									color: #03133a;
									font-size: rem(18);
									line-height: rem(20);
									font-weight: 700;
									height: 100%;
									max-width: calc(100% - rem(20));
									white-space: nowrap;
									overflow: hidden;
									text-overflow: ellipsis;
								}
							}

							&.active .el-input__wrapper {
								border-color: #a31984;
							}

							.el-select__caret {
								color: #03133a;
								font-size: rem(18);
							}
						}
					}
				}
			}

			.filter-actions {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;
				align-self: stretch;
				position: relative;

				.generate-button {
					background: #a31984;
					border-radius: rem(100);
					padding: rem(20) rem(32);
					display: flex;
					flex-direction: row;
					gap: rem(16);
					align-items: center;
					justify-content: center;
					width: rem(320);
					height: rem(60);
					position: relative;
					cursor: pointer;
					transition: all 0.3s ease;

					&.hovered {
						opacity: 0.8;
					}

					.generate-icon {
						width: rem(28);
						height: rem(28);
					}

					span {
						color: #ffffff;
						text-align: center;
						font-size: rem(22);
						line-height: rem(24);
						font-weight: 900;
						position: relative;
					}
				}

				.reset-button {
					border-radius: rem(100);
					border: rem(1) solid #a31984;
					display: flex;
					flex-direction: row;
					gap: rem(16);
					align-items: center;
					justify-content: center;
					width: rem(160);
					height: rem(60);
					position: relative;
					cursor: pointer;
					transition: all 0.3s ease;

					&.hovered {
						background: #a31984;

						span {
							color: #ffffff;
						}

						.reset-icon {
							filter: brightness(0) invert(1);
						}
					}

					.reset-icon {
						width: rem(20);
						height: rem(20);
					}

					span {
						color: #a31984;
						text-align: left;
						font-size: rem(20);
						line-height: rem(20);
						font-weight: 700;
						position: relative;
					}
				}
			}
		}

		&.mobile {
			padding: 0 rem(16);

			.filter-container {
				padding: rem(32);
				gap: rem(32);

				.filter-rows {
					gap: rem(16);
				}

				.filter-actions {
					flex-direction: column;
					gap: rem(16);

					.generate-button,
					.reset-button {
						width: 100%;
						padding: rem(20) 0;
					}
				}
			}
		}
	}
	.filter-item {
		display: flex;
		flex-direction: column;
		gap: rem(8);
		align-items: flex-start;
		justify-content: flex-start;
		flex: 1;
		position: relative;

		&.opacity-0 {
			opacity: 0;
		}

		.filter-label {
			padding: 0 rem(20);
			color: #03133a;
			text-align: left;
			font-size: rem(16);
			line-height: rem(16);
			font-weight: 400;
			position: relative;
		}

		:deep(.filter-select) {
			width: 100%;
			border-radius: rem(20);

			.el-input__wrapper {
				background: #ffffff;
				border-radius: rem(20);
				border: rem(2) solid rgba(163, 25, 132, 0.1);
				padding: rem(18) rem(24);
				box-shadow: none !important;
				height: rem(60);
				transition: all 0.3s ease;
				cursor: pointer;

				&:hover {
					border-color: rgba(163, 25, 132, 0.3);
				}

				&.is-focus {
					border-color: #a31984;
				}

				.el-input__inner {
					color: #03133a;
					font-size: rem(18);
					line-height: rem(20);
					font-weight: 700;
					height: 100%;
					max-width: calc(100% - rem(20));
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}
			}

			&.active .el-input__wrapper {
				border-color: #a31984;
			}

			.el-select__caret {
				color: #03133a;
				font-size: rem(18);
			}
		}
	}
	.detect_deviece_mobile & {
		padding: rem(60) 0;

		.section-header {
			padding: 0 rem(16);
		}

		.names-filter {
			padding: 0 rem(16);

			.filter-container {
				padding: rem(32);
				gap: rem(32);

				.filter-rows {
					gap: rem(16);
				}

				.filter-actions {
					flex-direction: column;
					gap: rem(16);

					.generate-button,
					.reset-button {
						width: 100%;
						padding: rem(20) 0;
					}
				}
			}
		}

		.filter-item {
			width: 100%;
		}
		.el-select__caret {
			display: flex !important;
			align-items: center !important;
			justify-content: center !important;
		}
	}
	// 组合模块样式
	.combinations-section {
		padding: rem(32) 0;
		display: flex;
		flex-direction: column;
		gap: rem(32);
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
		margin-bottom: rem(32);

		.combinations-container {
			padding: 0 rem(180);
			display: flex;
			flex-direction: column;
			gap: rem(24);
			align-items: center;
			justify-content: space-between;
			align-self: stretch;
			position: relative;

			.combination-row {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;
				align-self: stretch;
				position: relative;
				flex-wrap: wrap;
				gap: rem(24);
				width: 100%;
				&.mobile {
					.combination-card {
						flex-direction: column;
						gap: rem(24);
						align-items: flex-end;
					}
				}
			}

			.combination-card {
				background: #f7f3f3;
				border-radius: rem(36);
				padding: rem(28) rem(32);
				display: flex;
				flex-direction: row;
				gap: rem(84);
				align-items: center;
				justify-content: flex-start;
				align-self: stretch;
				// flex: 1;
				flex: 0 0 calc((100% - rem(24)) / 2); /* 使每个子元素占1/3的宽度 */
				// width: calc(50% - rem(12));
				position: relative;
				transition: all 0.3s ease;
				cursor: pointer;

				&.active {
					background: #ffffff;
					border: rem(1) solid #a31984;

					.combination-text {
						color: #a31984;
						font-weight: 700;
					}
				}

				&:hover {
					background: #ffffff;
					border: rem(1) solid #a31984;

					.combination-text {
						color: #a31984;
						font-weight: 700;
					}
				}

				.combination-text {
					color: #03133a;
					text-align: left;
					font-size: rem(18);
					line-height: rem(28);
					font-weight: 400;
					position: relative;
					flex: 1;
				}

				.see-more-button {
					border-radius: rem(12);
					border: rem(1) solid #a31984;
					padding: rem(8) rem(16);
					display: flex;
					flex-direction: row;
					gap: rem(8);
					align-items: center;
					justify-content: flex-start;
					position: relative;
					transition: all 0.3s ease;
					cursor: pointer;

					&.active {
						background: #a31984;

						span {
							color: #ffffff;
						}
					}

					span {
						color: #a31984;
						text-align: center;
						font-size: rem(12);
						line-height: rem(12);
						font-weight: 700;
						position: relative;
					}

					.arrow-icon {
						width: rem(6);
						height: rem(10);
					}
				}
			}
		}

		&.mobile {
			.section-header {
				padding: 0 rem(16);
			}

			.combinations-container {
				padding: 0 rem(16);

				.combination-row {
					flex-direction: column;
					gap: rem(16);
				}

				.combination-card {
					width: 100%;
				}
			}
		}
	}
	// 标题区域样式
	.section-header {
		padding: 0 rem(180);
		display: flex;
		flex-direction: row;
		gap: rem(16);
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		position: relative;

		.section-dot {
			background: #a31984;
			border-radius: rem(100);
			width: rem(8);
			height: rem(4);
			position: relative;
		}

		.section-title {
			color: #03133a;
			text-align: left;
			font-size: rem(28);
			line-height: rem(28);
			font-weight: 900;
			position: relative;
		}

		&.mobile {
			padding: 0 rem(16);
		}
	}

	.similar-name-section {
		&.mobile {
			display: flex;
			flex-direction: column;
			gap: rem(24);

			padding-top: rem(32);
		}
	}

	// 相似名字卡片区域样式
	.similar-names-list {
		padding: rem(32) rem(180);
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: rem(24);
		align-items: start;
		justify-content: space-between;
		width: 100%;
		box-sizing: border-box;
		position: relative;

		.name-card-link {
			text-decoration: none;
		}

		.name-card {
			background: linear-gradient(101.3deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.6) 70%, rgba(255, 255, 255, 0) 100%);
			border-radius: rem(36);
			border: rem(1) solid rgba(3, 19, 58, 0.04);
			padding: rem(24);
			display: flex;
			flex-direction: column;
			gap: rem(16);
			align-items: flex-start;
			justify-content: flex-start;
			width: 100%;
			height: rem(274);
			position: relative;
			box-shadow: 0 rem(2) rem(4) 0 rgba(0, 0, 0, 0.08);
			transition: all 0.3s ease;
			cursor: pointer;
			box-sizing: border-box;

			&:hover {
				border-color: #a31984;
				box-shadow: none;
			}

			.card-header {
				display: flex;
				flex-direction: row;
				gap: rem(8);
				align-items: center;
				justify-content: flex-start;
				align-self: stretch;
				position: relative;

				.card-name {
					color: #03133a;
					text-align: left;
					font-size: rem(18);
					line-height: rem(20);
					font-weight: 900;
					position: relative;
				}

				.card-gender-icon {
					width: rem(16);
					height: rem(16);
					position: relative;

					img {
						width: 100%;
						height: 100%;
					}
				}
			}

			.card-pronunciation {
				background: #f7f3f3;
				border-radius: rem(8);
				padding: rem(4) rem(8);
				color: #03133a;
				text-align: left;
				font-size: rem(13);
				line-height: rem(14);
				font-weight: 400;
				font-style: italic;
				position: relative;
			}

			.card-divider {
				border-top: rem(1) dashed rgba(3, 19, 58, 0.1);
				align-self: stretch;
				height: 0;
				position: relative;
			}

			.card-details {
				display: flex;
				flex-direction: column;
				gap: rem(16);
				align-items: flex-start;
				justify-content: flex-start;
				align-self: stretch;
				position: relative;

				&.mobile {
					flex-direction: row;
					gap: rem(16);
					.card-detail {
						width: 50% !important;
					}
				}

				.card-detail {
					display: flex;
					flex-direction: column;
					gap: rem(8);
					align-items: flex-start;
					justify-content: flex-start;
					align-self: stretch;
					position: relative;

					.detail-label {
						color: #a31984;
						text-align: left;
						font-size: rem(12);
						line-height: rem(12);
						font-weight: 200;
						position: relative;
						align-self: stretch;
					}

					.detail-value {
						color: #03133a;
						text-align: left;
						font-size: rem(13);
						line-height: rem(14);
						font-weight: 700;
						position: relative;
						align-self: stretch;
						display: flex;
						gap: rem(7);

						&.mobile {
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
							display: inline-block;
						}
					}
				}
			}

			.card-popularity {
				border-radius: rem(8);
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;
				align-self: stretch;
				position: relative;

				.popularity-label {
					color: #a31984;
					text-align: left;
					font-size: rem(12);
					line-height: rem(12);
					font-weight: 200;
					position: relative;
				}

				.popularity-value {
					background: #a31984;
					border-radius: rem(8);
					padding: rem(4) rem(8);
					color: #ffffff;
					text-align: center;
					font-size: rem(14);
					line-height: rem(14);
					font-weight: 900;
					font-style: italic;
					height: rem(22);
					display: flex;
					align-items: center;
					justify-content: center;
				}
			}
		}

		&.mobile {
			padding: 0 rem(16);
			grid-template-columns: 1fr;
			gap: rem(16);
		}
		.ad-grid-full-width {
			grid-column: 1 / -1;
		}
	}
}
</style> 